export const AUTH_RECOVERY_ELIGIBLE = Symbol.for('revieworks.auth-recovery-eligible');

export type AuthRecoveryRequestInit = RequestInit & {
  [AUTH_RECOVERY_ELIGIBLE]?: boolean;
};
